<template>

  <div class="bucket-tabs">
    <div class="tabs" style="margin-bottom: 0;">
      <ul>
        <li
          v-for="bucket in sortedBuckets"
          :key="bucket.id"
          :class="{'is-active': bucket.id === activeBucketId}"
        >
          <a @click="$emit('select', bucket.id)">
            {{ bucket.label }}
            <span
              class="icon is-small bucket-action"
              @click.stop="handleEdit(bucket)"
              style="margin-left: 0.25rem;"
            >
              <i class="fas fa-pencil-alt" style="font-size: 0.65rem;"></i>
            </span>
            <span
              class="icon is-small bucket-action"
              @click.stop="handleDelete(bucket)"
            >
              <i class="fas fa-times" style="font-size: 0.65rem;"></i>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>

</template>
<script>

  export default {

    props: {
      buckets: {
        type: Array,
        required: true,
      },
      activeBucketId: {
        type: Number,
        required: false,
        default: null,
      },
    },

    computed: {

      sortedBuckets () {
        return [...this.buckets].sort((a, b) => a.sort_order - b.sort_order);
      },

    },

    methods: {

      handleEdit (bucket) {
        this.$emit('edit', bucket);
      },

      handleDelete (bucket) {
        if (!confirm(`Delete bucket "${bucket.label}"? All plays within it will also be deleted.`)) {
          return;
        }
        this.$emit('delete', bucket);
      },

    },
  };

</script>

<style lang="scss" scoped>
  .bucket-action {
    opacity: 0.3;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }
</style>
